<template>
    <section>
        <div class="home-topactions grid fixed fixed-max-sm xs-grid-cols-1">
            <div class="text-center" v-for="(action, i) in actionsItems" :key="i">
                <div class="img-wrapper">
                    <img :src="action.image" :alt="action.title" loading="lazy">
                </div>
                <h2 class="f2 text-bold m-t-2">{{ action.title }}</h2>
                <p class="f4">{{ action.description }}</p>
                <a class="secondary btn regular" :href="action.href" :aria-label="action.cta + ' - ' + action.title">{{ action.cta }}</a>
            </div>
        </div>
    </section>
</template>

<script src="./home-topactions.js"></script>

<style lang="scss">
    @use "./home-topactions.scss" as *;
</style>